"use client";

import { faArrowDown } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import { motion, Variants } from "framer-motion";

export function MainVisual() {
  // 1. itemVariants
  const itemVariants: Variants = {
    hidden: {
      y: 80, // 시작 위치를 더 아래로
      opacity: 0,
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        damping: 30,
        stiffness: 60,
      },
    },
  };

  // 2. containerVariants
  const containerVariants: Variants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.4,
      },
    },
  };

  // 3. 화살표 아이콘을 위한 variants
  const arrowVariants: Variants = {
    bounce: {
      y: [0, -10, 0],
      transition: {
        duration: 1.5,
        repeat: Infinity,
        repeatType: "loop",
        ease: "easeInOut",
        delay: 2,
      },
    },
  };
  return (
    <div className=" w-full xl:max-w-[1280px] mx-auto px-5 xl:px-0">
      <motion.div
        className="mt-20 md:mt-32 xl:mt-40"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.p
          className="text-2xl md:text-5xl xl:text-7xl xl:leading-24 tracking-tight leading-9 md:leading-16 text-black-100"
          variants={itemVariants}
          style={{ fontFamily: "pre-bold, sans-serif" }}
        >
          더 나은 삶을 위한 시도
        </motion.p>
        <motion.p
          className="text-2xl md:text-5xl xl:text-7xl tracking-tight  leading-9 md:leading-16 xl:leading-24  text-softGray-30"
          variants={itemVariants}
          style={{ fontFamily: "pre-bold, sans-serif" }}
        >
          누구나 필요한 정보와 지식을 얻고,
          <br />더 넓은 세상으로 나아가며,
          <br />
          함께 사회변화를 만들어 가길 바랍니다.
        </motion.p>

        <motion.div
          className="w-full 
                      h-[72px]          
                      md:h-[120px]      
                      lg:h-[150px]      
                      xl:h-[182px]       
                      relative overflow-hidden my-28"
          variants={itemVariants}
        >
          <Image
            src="/assets/images/page/main/mainImage.jpg"
            alt="backgroundIMG"
            fill
            style={{ objectFit: "cover" }}
          />
          <div className="w-full h-full absolute inset-0 bg-black/34 z-10" />
        </motion.div>

        <motion.div
          className="mx-auto flex justify-center items-center my-10"
          variants={arrowVariants}
          initial="visible"
          animate="bounce"
        >
          <FontAwesomeIcon
            icon={faArrowDown}
            color="var(--color-midGray-30)"
            className="text-lg "
            size="2x"
          />
        </motion.div>
      </motion.div>
    </div>
  );
}
